export default (list) => {
  const viewList = [
    'job.list',
    'candidatelist.view',
    'resumepool.list',
  ];

  const routeList = {
    'job.list': 'ActiveJobListView',
    'candidatelist.view': 'CandidateListOfListView',
    'resumepool.list': 'ResumePoolView',
  };

  return routeList[
    viewList.filter((viewItem) => !list.some((perListItem) => perListItem === viewItem))[0]
  ];
};
